export default {
  CLEAR_CURRENT: 'RECYCLING_CLEAR_CURRENT',
  GET_REQUEST: 'RECYCLING_GET_REQUEST',
  GET_SUCCESS: 'RECYCLING_GET_SUCCESS',
  GET_FAILURE: 'RECYCLING_GET_FAILURE',

  SAVE_REQUEST: 'RECYCLING_SAVE_REQUEST',
  SAVE_SUCCESS: 'RECYCLING_SAVE_SUCCESS',
  SAVE_FAILURE: 'RECYCLING_SAVE_FAILURE',

  GETALL_REQUEST: 'RECYCLING_GETALL_REQUEST',
  GETALL_SUCCESS: 'RECYCLING_GETALL_SUCCESS',
  GETALL_FAILURE: 'RECYCLING_GETALL_FAILURE',

  DELETE_REQUEST: 'RECYCLING_DELETE_REQUEST',
  DELETE_SUCCESS: 'RECYCLING_DELETE_SUCCESS',
  DELETE_FAILURE: 'RECYCLING_DELETE_FAILURE',    

  UPDATE_REQUEST: 'RECYCLING_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'RECYCLING_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'RECYCLING_UPDATE_FAILURE'    

};